import React from 'react';
import PropTypes from 'prop-types';

export const HowItWorks = ({ howItWorks }) => (
  <section className="section">
    <div className="container text-center">
      <h2 className="mb-50px">How it works</h2>

      <div className="row mb--30px">
        {howItWorks.map(({ image, title, description }, key) => (
          <div className="col-12 col-md-4 mb-30px" key={key}>
            <div className="rounded bg-blue-light mb-3">
              <img
                className="img-fluid how-it-works-image"
                srcSet={`${image}?auto=compress,format&h=300 1x, ${image}?auto=compress,format&h=600 2x`}
                src={`${image}?auto=compress,format&h=300`}
                alt={title}
                height="300"
                fetchPriority="high"
              />
            </div>
            <div className="font-weight-bold mb-3 how-it-works-title">{title}</div>
            <div className="text-secondary px-2">{description}</div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

HowItWorks.propTypes = {
  howItWorks: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
    })
  ).isRequired,
};
